import { render, staticRenderFns } from "./CreateInvoicePrefix.vue?vue&type=template&id=ccb74452&"
import script from "./CreateInvoicePrefix.vue?vue&type=script&lang=js&"
export * from "./CreateInvoicePrefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports